import React, { Component } from "react";
import { Box } from "@material-ui/core";
import { connect } from "react-redux";
import { appService } from "../../App/app.service";
import FocusTable from "./FocusTable";
import RccCard from "../RccCard";

class NudgeCard extends Component {
  state = {
    loading: true,
    error: null,
  };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    this.setState({ loading: true, error: null });
    try {
      await this.props.getFocusRecommendationData();
    } catch (error) {
      console.error("Error loading nudge data:", error);
      this.setState({
        error: "Failed to load nudge data. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading } = this.state;
    const { FocusRecommendationData, title, redirectToDashboard, user } =
      this.props;

    // Get currentFiscalQuarter from user
    const currentFiscalQuarter = user?.currentFiscalQuarter;

    const tableData = FocusRecommendationData?.focusTableData || [];
    const tableConfig = FocusRecommendationData?.nudgeTableConfig || [];

    // Determine if we are effectively loading (initial load or missing data)
    const isEffectiveLoading =
      loading &&
      (!FocusRecommendationData || !FocusRecommendationData.focusTableData);

    return (
      <RccCard
        title={title || "Focus - Current Quarter"}
        isLoading={isEffectiveLoading}
        redirectToDashboard={redirectToDashboard}
        focusVariant={"current"}
        focusLabel={"Current Qtr Recommendations"}
        // Pass dummy functions to ensure icons appear, or real handlers if you have them
        onInfoClick={() => console.log("Info clicked")}
        onZoomClick={() => console.log("Zoom clicked")}
      >
        <Box
          style={{ flex: 1, width: "100%", overflow: "hidden", height: "100%" }}
        >
          <FocusTable
            data={tableData}
            config={tableConfig}
            loading={loading}
            emptyMessage={`No ${currentFiscalQuarter} recommendations for nudge at this time`}
          />
        </Box>
      </RccCard>
    );
  }
}

/* Redux */
const mapStateToProps = (state) => {
  const { user, FocusRecommendationData } = state.app;
  return {
    user: user,
    company: user?.company,
    FocusRecommendationData,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getFocusRecommendationData: () => {
    return appService.getFocusRecommendationData().then(
      (json) => {
        dispatch({ type: "get_Focus_Recommendation", json });
        return json;
      },
      (error) => {
        console.error("API error:", error);
        throw error;
      },
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NudgeCard);
